module.exports = __webpack_public_path__ + "static/media/birthday.750cea7b.jpg";